/*
 * Dependencies
 */
var $ = require('jquery');

module.exports = {
    calculateWidth: function () {
        var _self = this,
					$popUpContainer = _self.$el.find('.article-content'),
					$track = _self.$el.find('.slick-track'),
					$slide = _self.$el.find('.slick-slide');

        if( _self.$el.find('.mi-carousel').hasClass('mi-prevent-reinit')){
          return;
        }
        _self.$el.find('.mi-carousel.slick-slider.slick-initialized .slick-slide').each(function() {
					$(this).css({
							'maxWidth': $popUpContainer.width()
					});  
        });
    
        if ( $slide.length === 1 ) {
					$track.css({
							'left': '0px'
					});
        } else {
					$track.css({
							'left': '-' + $slide.width() + 'px'
					});
        }
    }
}
